import type { ReactNode } from "react";

export function Metric({ value, label, tone }: { value: ReactNode; label: string; tone?: string }) {
  return (
    <div className="ods-metric">
      <span className="ods-metric__value" style={tone ? { color: tone } : undefined}>
        {value}
      </span>
      <span className="ods-metric__label">{label}</span>
    </div>
  );
}
